import type { CSSProperties, ReactNode } from 'react';
import { X } from 'lucide-react';
import { Button } from '../../../../components/ui/button';

type RowSidePanelProps = {
  readonly title: string;
  readonly onClose: () => void;
  readonly children: ReactNode;
  readonly className?: string;
  readonly style?: CSSProperties;
  readonly testId?: string;
};

export function RowSidePanel({ title, onClose, children, className = '', style, testId }: RowSidePanelProps) {
  return (
    <div
      className={`w-96 flex-shrink-0 border-l border-border bg-muted/20 flex flex-col overflow-hidden ${className}`}
      data-testid={testId}
      style={style}
    >
      <div className="flex-shrink-0 flex items-center justify-between gap-2 px-2 py-1.5 border-b border-border bg-muted/30 select-none">
        <div className="text-xs font-medium text-foreground truncate" title={title}>
          {title}
        </div>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          onClick={onClose}
          title="Close"
          aria-label="Close"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex-1 min-h-0 overflow-auto p-2">{children}</div>
    </div>
  );
}
